/**
 * Fulfilment orchestration screens (P45 U74; FSD 5.2.5), spread into `SALES_ROUTES`.
 *
 * Each route names the permission the server guards the screen's primary READ with:
 * `/sales/allocations` reads `GET /sales-allocations` and `GET /sales-fulfilment-orders`, both
 * under `sales.order.read`; the pick screens read `GET /sales-picks[/{id}]` under
 * `sales.pick.read`. Every write is checked per action inside the screen.
 *
 * Nav ids (INT-W adds them to section s-5.2.5): `sales-allocations`, `sales-picks`
 * (`sales-shipments` already exists). Literal path strings for the conformance deep-link parser.
 */

import type { RouteRecordRaw } from 'vue-router'

import { FULFILMENT_PERMISSIONS } from '@/modules/sales/fulfilment/api'

export const FULFILMENT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/sales/allocations',
    name: 'sales-allocations',
    component: () => import('@/modules/sales/fulfilment/AllocationsView.vue'),
    meta: { titleKey: 'sales.u74.routeTitles.allocations', permission: FULFILMENT_PERMISSIONS.orderRead },
  },
  {
    path: '/sales/picks',
    name: 'sales-picks',
    component: () => import('@/modules/sales/fulfilment/PicksView.vue'),
    meta: { titleKey: 'sales.u74.routeTitles.picks', permission: FULFILMENT_PERMISSIONS.pickRead },
  },
  {
    path: '/sales/picks/:id(\\d+)',
    name: 'sales-pick',
    component: () => import('@/modules/sales/fulfilment/PickView.vue'),
    meta: { titleKey: 'sales.u74.routeTitles.pick', permission: FULFILMENT_PERMISSIONS.pickRead },
  },
]
